import { render, staticRenderFns } from "./CrudPrinter.vue?vue&type=template&id=9a261606&scoped=true"
import script from "./CrudPrinter.vue?vue&type=script&lang=js"
export * from "./CrudPrinter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a261606",
  null
  
)

export default component.exports